import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { getPaginationPayload } from '~/utils/pagination';
import { ITriageStore, IThunkGetMoreTriageRequests } from '../types';

const onGetMoreTriageRequests: IThunkGetMoreTriageRequests = thunk(
  // @ts-ignore
  async ({ setMoreTriageRequests }, payload, { getState }) => {
    const localState = getState() as ITriageStore;

    const paginationPayload = getPaginationPayload(localState.pagination);

    const { data } = await api.triage.getRequests({
      ...payload,
      ...paginationPayload,
    });

    setMoreTriageRequests(data);
  },
);

export default onGetMoreTriageRequests;
